import { useEffect, useState } from 'react';

import Helper from "Interfaces/Helper";

import FooterBtns from './SAFFooter';
import Desktop from './SAFDesktop';
import Mobile from './SAFMobile';
import Offcanvas from './SAFOffcanvas';
import { SAFPropsI } from './SAF.interface';
import { Filter } from 'Interfaces/general.interface';
import "GeneralComponents/CSS/_ComponentSearchAndFilter.min.css";

const mediaType = window.matchMedia("(min-width: 1200px)");
const senitationPattern = new RegExp(/^[A-Za-zא-תЁёА-я \u00C0-\u00FF\u0600-\u06FF 0-9\r\n\t?!. ,:'\ %$;\-@()*/""=&]*$/);

const ComponentSearchAndFilter: React.FC<SAFPropsI> = (props) => {

    const [filterValues, setFilterValues] = useState(["", "", "", "", ""]);
    const [searchword, setSearchword] = useState('');
    const [offcanvasIsOpen, setOffcanvasIsOpen] = useState(false);
    const [isFooterDisplayedWhenNoActiveFilters, setIsFooterDisplayedWhenNoActiveFilters] = useState(false);
    const [filters, setFilters] = useState<Filter[]>(mapFiltersByContentEditorChoices(props.showFilters, props.filters));

    const hasSearchInput = props.hasSearchInput;
    const noFilters = !props.showFilters || filters.filter(f => !!f).length === 0;
    const isDektop = mediaType.matches;
    const limitWidth = hasSearchInput && noFilters;
    const activeFiltersCount: number = getActiveFiltersCount(filterValues);


    useEffect(() => {
        const syncedFilters = mapFiltersByContentEditorChoices(props.showFilters, props.filters);
        setFilters(syncedFilters);
    }, [JSON.stringify(props.filters)]);

    useEffect(() => {
        const isSecureSearchword = checkSrtingSecurity(searchword);

        if (isSecureSearchword) {
            activateCallback(searchword, filterValues);
        }
    }, [JSON.stringify(filterValues)]);


    const onSearchChange = (event) => setSearchword(event.target.value);

    const handleSubmit = async (event) => {

        event.preventDefault();

        const isSecureSearchword = checkSrtingSecurity(searchword);

        if (!isSecureSearchword) return;

        activateCallback(searchword, filterValues);

    }

    const handleGASearch = (searchword: string, filterValues: string[]) => {
        const { componentType, disptitle } = props;
        const hasActiveFilters = filterValues.some(f => !!f);

        if (!hasActiveFilters && !searchword) return;

        const searchText = `search ${searchword} `;
        const filtersText = hasActiveFilters ? `filters ${filterValues.filter(f => f).join(', ')}` : '';

        Helper.handleLinkClicksGA4(componentType, disptitle, searchText + filtersText);
    }

    const toggleOpenOffcanvas = () => {
        document.body.classList.toggle("mst-offcanvas-body-fixed"); // prevents scrolling the body while offcanvas is open
        setOffcanvasIsOpen(prev => !prev);
    }

    const searchClear = (event) => {
        event.preventDefault();
        setSearchword('');
        activateCallback("", filterValues);
    }

    const updateFilterValue = (newValue: string, idx: number) => {
        const updatedFilters = [...filterValues];
        updatedFilters[idx] = newValue;
        setFilterValues(updatedFilters);
    }

    const resetFilter = (filterItemIndex: number) => {
        const filterSelect = document.getElementById("selectFilter_" + filterItemIndex) as HTMLSelectElement;
        updateFilterValue("", filterItemIndex);
        if (filterSelect) { filterSelect.selectedIndex = 0; };
    }

    const resetAllFilters = () => {
        const emptyFilters = ["", "", "", "", ""]
        updateFilterValues(emptyFilters);
    }

    function getActiveFiltersCount(filterValues: string[]): number { return filterValues.filter(f => f).length; }

    // characters check + invalid if only one character typed
    const checkSrtingSecurity = (value: string): boolean => (senitationPattern.test(value) && value.toString().length !== 1);

    const activateCallback = async (searchword: string, filterValues: string[]) => {
        handleGASearch(searchword, filterValues);
        // commits to the searchword value only when request is made
        await props.callbackFromComponentSearch(searchword, filterValues);
        setIsFooterDisplayedWhenNoActiveFilters(!!searchword);
    }

    const updateFilterValues = (filters: string[]) => { setFilterValues(filters) };

    function mapFiltersByContentEditorChoices(showFilters: boolean, filters: Filter[]) {
        // syncs 'filters' + 'showFilters' and 'filter.IsActive'
        // Return empty filters array in case 'showFilters' is false or 'props.filters' is null \ undefined
        if (!showFilters || !filters) return [null, null, null, null, null];
        // Check filter's IsActive property and Convert unactive filters to 'null'
        const syncedFilters: (Filter | null)[] = filters.map((filter) => (!!filter && filter.isActive)? filter : null);

        return syncedFilters;
    }

    // Display component only if there are filters or search input
    if (!hasSearchInput && noFilters) return null;

    return (
        <div className={`mst-content-search-and-filter mb-4 mx-auto ${props.isCalledFromContentShow? 'px-3': ''} px-md-0`}  >
                
                <div className={`serach-and-filer-wrapper mst-search-and-filter ${limitWidth ? 'small-width': ''}`}>

                    {
                        isDektop ?

                            <Desktop
                                componentId={props.componentId}
                                componentType={props.componentType}
                                disptitle={props.disptitle}
                                filters={filters}
                                filterValues={filterValues}
                                searchInputValue={searchword}
                                handleSubmit={handleSubmit}
                                onSearchInputChange={onSearchChange}
                                noFilters={noFilters}
                                searchClear={searchClear}
                                updateFilterValue={updateFilterValue}
                                hasSearchInput={hasSearchInput}
                            />

                        :
                            <>
                                <Mobile
                                    noFilters={noFilters}
                                    componentId={props.componentId}
                                    componentType={props.componentType}
                                    disptitle={props.disptitle}
                                    searchInputValue={searchword}
                                    handleSubmit={handleSubmit}
                                    onSearchInputChange={onSearchChange}
                                    searchClear={searchClear}
                                    toggleOffcanvas={toggleOpenOffcanvas}
                                    hasSearchInput={hasSearchInput}
                                    totalFiltersSelected={activeFiltersCount}
                                />

                                {
                                    !noFilters && 
                                    <Offcanvas
                                        componentId={props.componentId}
                                        filters={filters}
                                        filterValues={filterValues}
                                        updateFilterValues={updateFilterValues}
                                        offcanvasIsOpen={offcanvasIsOpen}
                                        toggleOffcanvas={toggleOpenOffcanvas}
                                    />
                                }

                            </>
                        
                    }

                    {
                        (props.componentType !== "Alphon") &&
                        <FooterBtns
                            componentId={props.componentId}
                            filters={filters}
                            filterValues={filterValues}
                            resetAllFilters={resetAllFilters}
                            resetFilter={resetFilter}
                            totalSearchResults={props.totalSearchResults}
                            isDisplayedWhenNoActiveFiltersExist={isFooterDisplayedWhenNoActiveFilters}
                        />
                    }

            </div>
        </div>
    );

}

export default ComponentSearchAndFilter;